import { RefObject, useEffect } from 'react';
import {
  Outlet,
  useMatch,
  useNavigate,
  // useLocation,
  useOutletContext,
} from 'react-router-dom';
import { SendMessage } from 'react-use-websocket';
import { Tabs, apiAbortController } from '@ui/src';
import { useAppSelector, useAppDispatch } from '@store';
import { setScrolled, setSelectedChannel } from './store/slices/general';

import ROUTES from '../routes';

import cn from './messages.module.css';

const MessagesRequests = () => {
  const {
    selectedUserId,
    sendMessage,
    scrollRef,
    search,
    connectionStatus,
    prevConnectionStatus,
  } = useOutletContext<{
    selectedUserId?: string;
    sendMessage: SendMessage;
    scrollRef: RefObject<HTMLDivElement | null>;
    search?: string;
    connectionStatus?: string;
    prevConnectionStatus?: string;
  }>();

  const match = useMatch(ROUTES.MESSAGES_REQUEST);
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const {
    // requestChannelsPagination,
    // requestChannelsByTypeIsLoading,
    selectedChannel,
  } = useAppSelector((state) => state.messages.general);

  // const { pathname } = useLocation();

  useEffect(() => {
    if (match) {
      navigate(ROUTES.MESSAGES_REQUEST_UNREAD);
    }
  }, [match]);

  useEffect(() => {
    let title = 'Messages: Requests';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  return (
    <>
      <div className={cn.messagesTabsWrapper}>
        <Tabs
          wrapperClassName={cn.messagesTabs}
          itemClassName={cn.messagesTabsItem}
          onRouterClick={() => {
            apiAbortController.abortPendingRequest();

            dispatch(setScrolled(false));

            if (selectedChannel) {
              dispatch(setSelectedChannel(undefined));

              sendMessage(
                JSON.stringify({
                  event: 'unsubscribe',
                  data: { channelId: selectedChannel.id },
                }),
              );
            }
          }}
          tabs={[
            {
              name: (
                <div
                  className={`${cn.messageTabItemTitle} ${cn.messageSubTabItemTitle}`}
                >
                  {/* {`Unread ${
                    pathname.includes(ROUTES.MESSAGES_REQUEST_UNREAD) &&
                    !requestChannelsByTypeIsLoading &&
                    requestChannelsPagination
                      ? `(${requestChannelsPagination?.totalCount})`
                      : ''
                  }`} */}
                  Unread
                </div>
              ),
              path: `${ROUTES.MESSAGES_REQUEST_UNREAD}${search || ''}`,
            },
            {
              name: (
                <div
                  className={`${cn.messageTabItemTitle} ${cn.messageSubTabItemTitle}`}
                >
                  {/* {`In Progress ${
                    pathname.includes(ROUTES.MESSAGES_REQUEST_IN_PROGRESS) &&
                    !requestChannelsByTypeIsLoading &&
                    requestChannelsPagination
                      ? `(${requestChannelsPagination?.totalCount})`
                      : ''
                  }`} */}
                  In Progress
                </div>
              ),
              path: `${ROUTES.MESSAGES_REQUEST_IN_PROGRESS}${search || ''}`,
            },
            {
              name: (
                <div
                  className={`${cn.messageTabItemTitle} ${cn.messageSubTabItemTitle}`}
                >
                  Inactive
                </div>
              ),
              path: `${ROUTES.MESSAGES_REQUEST_COMPLETED}${search || ''}`,
            },
            {
              name: (
                <div
                  className={`${cn.messageTabItemTitle} ${cn.messageSubTabItemTitle}`}
                >
                  All
                </div>
              ),
              path: `${ROUTES.MESSAGES_REQUEST_ALL}${search || ''}`,
            },
          ]}
          enableRouting
        />
      </div>
      <Outlet
        context={{
          selectedUserId,
          sendMessage,
          scrollRef,
          search,
          connectionStatus,
          prevConnectionStatus,
        }}
      />
    </>
  );
};

export default MessagesRequests;
